module.exports = require('./convert')(
  "exportsfunc:;Qabdghijklmqvwyz",
  "εχπορτσφθνψ¨΄:αβδγηιξκλμ;ωςυζ"
)
